export default "__VITE_ASSET__CB_j3hOn__"